import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import {
  KoTitle, KoText,
  KoModal, KoButton, KoLoader,
  KoToast,
  KoTable,
  KoTooltips,
  KoPagination,
  KoDrawer,
  KoBadge,
  KoForm,
  KoFormBuilder,
  KoSelect

  // KoCollapse,
  // KoEmpty
} from 'packages';
import KoIcon from '@kwapio/icons';
import { ClientsAPI } from '../customers.service';
import { add, remove } from 'shared/store/breadcrumbSlice';
import styles from './customers.module.scss';
import ClientDetails from './deatils';
import { PRO_ITEMS_COLUMNS, PROJECT_ITEMS_COLUMNS } from './constant';
import Preview from './deatils/preview';
import KoToolBar from 'shared/components/tickettable/toolbar';
import Comments from './comments';
import moment from 'moment';
// import { getCookie } from 'shared/utils/cookies';

function Clients() {
  const [rowList, setDataList] = useState();
  const [selectedCustomers, setSelectedCustomers] = useState([]);
  const [sendMessageModal, setSendMessageModal] = useState(false);
  const [currentRecord, setCurrentRecord] = useState();
  const [isLoading, setLoading] = useState(false);
  const [isOpenDelete, setDeleteModal] = useState(false);
  const [isOpenLinkWorkspace, setLinkWorkspaceModal] = useState(false);
  const [openCustomerModal, setOpenCustomerModal] = useState(false);
  const [openTicketsModal, setOpenTicketsModal] = useState(false);
  const [isOpenCustomer, setOpenCustomer] = useState(false);
  const [totalCount, setTotalCount] = useState();
  const [openComments, setOpenComments] = useState(false);
  const [isOpenCommentsModalNew, setCreateCommentNew] = useState(false);
  const [sendForm] = KoForm.useForm();
  const [linkWorkspaceForm] = KoForm.useForm();
  const [currentTemplate ] = useState(null);
  const [ticketList, setTicketList] = useState([]);
  const [templateList, setTemplateList ] = useState([]);
  const [workspaceList, setWorkspaceList ] = useState([]);
  const [workflows, setWorkflows] = useState([]);
  const [accountType, setAccountType] = useState([]);

  const [pagination, setPagination] = useState({
    size: 10,
    offset: 0,
    page: 1,
    limit: 10
  });
  const dispatch = useDispatch();

  const onPagination = (page, other) => {
    const query = {
      size: other,
      page: page

    };
    const p = Object.assign(pagination, query);
    setPagination(p);
    getClients(p);
  };

  const getWorkflows = async() => {
    try {
      const res = await ClientsAPI.getCustomerWorkflow();
      setWorkflows(res);
    } catch (error) {
      console.error('Error fetching workflows:', error);
    }
  };

  const getWorkspaceList = async() => {
    try {
      const res = await ClientsAPI.getWorkspaceList();
      setWorkspaceList(res['workspaces']);
    } catch (error) {
      console.error('Error fetching workflows:', error);
    }
  };
  
  const getAccountType = async() => {
    try {
      const res = await ClientsAPI.getCustomerTypes();
      setAccountType(res);
    } catch (error) {
      console.error('Error fetching account types:', error);
    }
  };

  const getTemplates = () => {
    setLoading(true);
    ClientsAPI.getTemplates().then(
      (data) => {
        setTemplateList();
        setTemplateList(data['templates']);
        setLoading(false);
      },
      (err) => {
        setLoading(false);
      }
    );
  };


  const onSort = (key, type) => {
    let q = pagination;
    q['sort'] = `${key}:${type}`;
    getClients(q);
  };


  useEffect(() => {
    dispatch(remove());
    dispatch(add([
      {
        title: 'Admin Console',
        path: 'admin/settings'
      },
      {
        title: 'customers'
      }
    ]));

    getTemplates();
    getAccountType();
    getWorkflows();
    getClients(pagination);
  }, []);



  const getClients = (p) => {
    setLoading(true);
    ClientsAPI.getClients(p ? p : pagination).then(
      (data) => {
        setDataList();
        setTotalCount(data['totalCount']);
        setDataList(data['customers']);
        setLoading(false);
      },
      (err) => {
        setLoading(false);
      }
    );
  };

  const getComments = (id) => {
    setLoading(true);
    ClientsAPI.getComments(id).then(
      (data) => {
        setLoading(false);
        setCurrentRecord(data);
        setOpenComments(true);
      },
      (err) => {
        setLoading(false);
      }
    );
  };

  // const onSearchText=(text)=>{
  //   let q = pagination;
  //   if(text){
  //     q['search'] = text;
  //   }
  //   else{
  //     delete q?.['search'];
  //   }
  //   getClients(q);
  // };

  const handleFinishDelete = () => {
    setLoading(true);
    if (selectedCustomers?.length > 0) {

      ClientsAPI.deleteBulkCustomers({customerIds:selectedCustomers}).then(
        (data) => {
          getClients();
          KoToast.success('Delete successfully');
          setDeleteModal(false);
          setLoading(false);
        },
        (err) => {
          setLoading(false);
        }
      );
    } else {
      ClientsAPI.deleteById(currentRecord?.customerId).then(
        (data) => {
          getClients();
          KoToast.success('Delete successfully');
          setDeleteModal(false);
          setLoading(false);
        },
        (err) => {
          setLoading(false);
        }
      );
    }

  };

  const onCellClick = (row) => {
    setCurrentRecord(row);
    setOpenCustomer(true);
  };

  const onSearchText = (text) => {
    let q = pagination;
    q['search'] = text;
    getClients(q);
  };

  const onChangeStatus = (key) => {
    let q = pagination;
    if (key) {
      q['status'] = key.toString();
    } else {
      delete q?.['status'];
    }

    getClients(q);
  };


  const onChangeType = (key) => {
    let q = pagination;
    if (key) {
      q['type'] = key.toString();
    } else {
      delete q['type'];
    }
    getClients(q);
  };

  // const onCopyTicket = (row) => {
  //   setCopy(true);
  //   navigator.clipboard.writeText(`${window.location.origin}/open/ticket/${getCookie("accountId")}/${row?.workspaceId}/${row?.ticketId}`);
  // };

  const onRowSelection = (ticketId) => {
    setSelectedCustomers(ticketId);
  };

  const getSupportTickets = (row) => {
    setLoading(true);
    ClientsAPI.getSupportTickets(row?.customerId).then(
      (data) => {
        setLoading(false);
        setTicketList(data['tickets']);
        setOpenTicketsModal(true);
      },
      (err) => {
        setLoading(false);
      }
    );
  };

  const columnsRight = [{
    title: '',
    dataIndex: 'x',
    key: 'x',
    fixed: 'right',
    width: 40,
    render: (text, row) => {
      return <div className={`${styles.circle} tableBtn columnsRight`} onClick={() => setCurrentRecord(row)}>
        {/* <KoTooltips title={copy ? 'Copied' : 'Copy'}>
          <KoButton onClick={() => onCopyTicket(row)} className={'btn'} iconBtn={true} icon={<KoIcon width={14} height={14} name={'CopyOutlined'} />} />
        </KoTooltips> */}
        <KoTooltips title={'Support Tickets'}>
          <KoBadge count={row?.ticketsCount} >
            <KoButton onClick={() => getSupportTickets(row)} className={'btn'} iconBtn={true} icon={<KoIcon width={14} height={14} name={'IssuesOutlined'} />} />
          </KoBadge>
        </KoTooltips>
        <KoTooltips title={'Notes'}>
          <KoBadge count={row?.commentsCount} >
            <KoButton onClick={() => { setCurrentRecord(row); setOpenComments(true); }} className={'btn'} iconBtn={true} icon={<KoIcon width={14} height={14} name={'ChatOutlined'} />} />
          </KoBadge>
        </KoTooltips>
        <KoTooltips title={'Edit'}>
          <KoButton onClick={() => setOpenCustomerModal(row)} className={'btn'} iconBtn={true} icon={<KoIcon width={14} height={14} name={'EditOutlined'} />} />
        </KoTooltips>
        <KoTooltips title={'Delete'}>
          <KoButton onClick={() => { setDeleteModal(true); setCurrentRecord(row); }} className={'btn'} iconBtn={true} icon={<KoIcon width={14} height={14} name={'DeleteOutlined'} />} />
        </KoTooltips>
      </div>;
    }
  }];

  const NotificationTemplates = ({ value, onChange }) => (
    <KoSelect value={value}
      showSearch
      onChange={v => onChange(v)}
      placeholder='Select notification template'
      options={templateList?.map((temp) => ({
        label: temp?.name,
        value: temp?.templateId
      }))}
    />
  );

  const WorkspaceList = ({ value, onChange }) => (
    <KoSelect
      placeholder="Select workspace"
      showSearch
      mode="multiple"
      value={value}
      optionFilterProp="label"
      filterOption={(input, option) =>
        option.label.toLowerCase().includes(input.toLowerCase())
      }
      onChange={(v) => {onChange(v);}}
      options={workspaceList?.map((workspace) => ({
        label: workspace?.name,
        value: workspace?.workspaceId
      }))}
    />
  );



  const sendMeta = {
    columns: 4,
    formItemLayout: null,
    initialValues: {},
    colon: true,
    fields: [
      { key: 'templateId', label: 'Notification Template', colSpan: 4, widget: NotificationTemplates }
    ]
  };

  const linkMeta = {
    columns: 4,
    formItemLayout: null,
    initialValues: {},
    colon: true,
    fields: [
      { key: 'workspaces', label: 'Workspace', colSpan: 4, widget: WorkspaceList }
    ]
  };

  const handleSendSubmit = (values) => {
    console.log('send', values);
    setLoading(true);
    let data = {
      ...values,
      selectedCustomers: selectedCustomers
    };
    ClientsAPI.sendEmial(data).then(
      (data) => {
        setLoading(false);
        setSendMessageModal(false);
        sendForm.resetFields();
        KoToast.success('Notification sent successfully');
      },
      (err) => {
        setLoading(false);
      }
    );
  };

  const handleLinkWorkspaceSubmit = (values) => {
    setLoading(true);
    let q={
      customerIds: selectedCustomers.toString()
    };
    ClientsAPI.linkWorkspace(values, q).then(
      (data) => {
        setLoading(false);
        setLinkWorkspaceModal(false);
        linkWorkspaceForm.resetFields();
        KoToast.success('Workspace linked successfully');
      },
      (err) => {
        setLoading(false);
      }
    );
  };

  const handleExport = async() => {
    setLoading(true);
    try {
      const data = await ClientsAPI.getClients();
      const customers = data?.customers || [];
      if (!customers.length) return;
      const getStatusLabel = (value) => {
        const found = workflows.find(w => w.value === value);
        return found ? found.label : value;
      };
      const getTypeLabel = (value) => {
        const found = accountType.find(t => t.value === value);
        return found ? found.label : value;
      };
      const csvHeaders = [
        'Customer ID',
        'Company Name',
        'Name',
        'Email',
        'Mobile',
        'Designation',
        'Website',
        'EIN / PAN',
        'Status',
        'Account Type',
        'Created At'
      ];
      const csvRows = customers.map(c => [
        c.customerId,
        c.companyName,
        c.firstName + ' ' + c.lastName,
        c.email,
        c.mobile?.phoneNumber || '',
        c.designation,
        c.url,
        c.PAN,
        getStatusLabel(c.status),
        getTypeLabel(c.type),
        moment(c.createdAt).format('YYYY-MM-DD HH:mm:ss')
      ]);
      const csvContent = [
        csvHeaders.join(','),
        ...csvRows.map(r => r.join(','))
      ].join('\n');

      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.setAttribute('download', `customer_${moment().format('YYYY-MM-DD')}.csv`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return <div className={styles.wrapper}>
    {isLoading && <KoLoader />}
    <div className={styles.customerList}>
      <div className={styles.tableData}>
        <div className={'tableCard'}>
          <KoToolBar
            className={styles.toolbar}
            title={'Clients'}
            search={{ visible: true, onChange: (e) => { onSearchText(e); }, placeholder: 'Search by client name' }}
            isExport={true}
            handleExport={handleExport}
            buttonList={[{
              label: 'Link Wokspace',
              type: 'primary',
              disabled: selectedCustomers?.length === 0,
              onClick: () => {getWorkspaceList(); setLinkWorkspaceModal(true);}
            }, {
              label: 'Delete',
              type: 'primary',
              disabled: selectedCustomers?.length === 0,
              danger: true,
              onClick: () => setDeleteModal(true)
            }, {
              label: 'Notify Customers',
              icon: <KoIcon width={14} height={14} color={'#fff'} name={'SendOutlined'} />,
              type: 'default',
              disabled: selectedCustomers?.length === 0,
              onClick: () => setSendMessageModal(true)
            }]}
            onChangeStatus={onChangeStatus}
            onChangeType={onChangeType}
            filterOptions={{
              workflow: workflows,
              activityType: accountType
            }}
            Bulk={{
              visible: false
            }}
          />
          <KoTable rowKey='customerId'
            onCellClick={onCellClick}
            refreshData={getClients}
            onSort={onSort}
            onRowSelection={onRowSelection}
            data={{ columns: PRO_ITEMS_COLUMNS, rows: rowList }}
            extraColumnsRight={columnsRight} />
          <KoPagination current={parseInt(pagination.page) || 1}
            total={totalCount}
            showTotal={(total, range) =>
              `${range[0]}-${range[1]} of ${total} records`
            }
            pageSize={pagination.limit}
            defaultCurrent={pagination.page}
            onChange={onPagination}
            showQuickJumper={false}
            simple={false}
            responsive={false} />
        </div>
        {/* {groupsRowList?.length > 0 ? <KoCollapse expandIconPosition="end" items={groupsRowList} defaultActiveKey={groupsRowList.length > 0 ? [groupsRowList[0].key] : ['1']} />: <KoEmpty  title="No Customers found" label="Create a new ticket"  />} */}

      </div>
    </div>

    <KoModal
      title={selectedCustomers?.length === 0 ? `Delete Customer ${currentRecord?.companyName?.toUpperCase()}` : `Delete Customers`}
      centered
      open={isOpenDelete}
      afterClose={() => { setCurrentRecord(); }}
      handleOk={() => { setCurrentRecord(); setDeleteModal(false); }}
      onClose={() => { setCurrentRecord(); setDeleteModal(false); }}
      width={580}
      // maskClosable={false}
      footer={[
        <KoButton key='cancel' label='Cancel' onClick={() => setDeleteModal(!isOpenDelete)} />,
        <KoButton key='reset' loading={isLoading} color="danger" variant="solid" type='primary' label='Delete' onClick={() => handleFinishDelete()} />
      ]}
    >
      {isLoading && <KoLoader circle={false} />}
      <div className={styles.delWrapper}>
        <KoTitle level={5} text={`Are you sure you want to delete this Customer?`} />
        <KoText text={`This action is irreversible, and it will result in the removal of their associated data.`} />
      </div>
    </KoModal>

    {openCustomerModal && <ClientDetails getCustomers={getClients} openCustomerModal={openCustomerModal} setCurrentRecord={setCurrentRecord} setOpenCustomerModal={() => setOpenCustomerModal(false)} customerId={currentRecord?.customerId} />}

    <KoModal
      title={`${currentRecord?.companyName}`}
      centered
      open={isOpenCustomer}
      afterClose={() => { setCurrentRecord(); }}
      handleOk={() => { setCurrentRecord(); setOpenCustomer(false); }}
      onClose={() => { setCurrentRecord(); setOpenCustomer(false); }}
      width={'99vw'}
      height={'97vh'}
      footer={[]}
    >
      <div className={styles.delWrapper}>
        <Preview settings={currentRecord} form={''} getByIdSettings={getClients} />
      </div>
    </KoModal>
    <KoDrawer
      placement="right"
      closable={false}
      title={
        <div className={styles.headerTitle}>
          <KoTitle text={'Comments'} level={4} className={styles.title} />
          <KoButton type='primary' icon={<KoIcon color="#FFF" width={18} height={18} name={'PlusOutlined'} />} label={'Add a Comment'} onClick={() => setCreateCommentNew(true)} />
        </div>
      }
      onClose={() => setOpenComments(false)}
      open={openComments}
      width={750}
      footer={false}
    >
      {(openComments) && <Comments updateCount={() => getComments(currentRecord?.customerId)} emptyRowHeight={`${styles.wrapperOverflow} `} customerId={currentRecord?.customerId} setCreateComment={setCreateCommentNew} isOpenCommentsModal={isOpenCommentsModalNew} />}
    </KoDrawer>
    <KoModal
      title={`Notify Customer`}
      centered
      open={sendMessageModal}
      afterClose={() => { sendForm.resetFields(); setSendMessageModal(); }}
      handleOk={() => { sendForm.resetFields(); setSendMessageModal();}}
      onClose={() => { sendForm.resetFields(); setSendMessageModal();}}
      width={750}
      footer={[
        <KoButton key='cancel' label='Cancel' onClick={() => { setSendMessageModal(false); sendForm.resetFields(); }} />,
        <KoButton key='create' loading={isLoading} type='primary' label={`${currentTemplate?.folderId ? 'Send' : 'Send'}`} onClick={() => sendForm.submit()} />
      ]}
    >
      <div className={styles.modalContent}>
        <KoForm form={sendForm} layout="vertical" onFinish={handleSendSubmit} onSubmit={handleSendSubmit}>
          <KoFormBuilder form={sendForm} meta={sendMeta} />
        </KoForm>
      </div>
    </KoModal>
    <KoModal
      title={`Link Workspace to Customers`}
      centered
      open={isOpenLinkWorkspace}
      afterClose={() => { linkWorkspaceForm.resetFields(); setLinkWorkspaceModal(); }}
      handleOk={() => { linkWorkspaceForm.resetFields(); setLinkWorkspaceModal();}}
      onClose={() => { linkWorkspaceForm.resetFields(); setLinkWorkspaceModal();}}
      width={750}
      footer={[
        <KoButton key='cancel' label='Cancel' onClick={() => { setLinkWorkspaceModal(false); sendForm.resetFields(); }} />,
        <KoButton key='create' loading={isLoading} type='primary' label={`Link`} onClick={() => linkWorkspaceForm.submit()} />
      ]}
    >
      <div className={styles.modalContent}>
        <KoForm form={linkWorkspaceForm} layout="vertical" onFinish={handleLinkWorkspaceSubmit} onSubmit={handleLinkWorkspaceSubmit}>
          <KoFormBuilder form={linkWorkspaceForm} meta={linkMeta} />
        </KoForm>
      </div>
    </KoModal>

    <KoModal
      title={`Support Tickets`}
      centered
      open={openTicketsModal}
      afterClose={() => { linkWorkspaceForm.resetFields(); setOpenTicketsModal(); }}
      handleOk={() => { linkWorkspaceForm.resetFields(); setOpenTicketsModal();}}
      onClose={() => { linkWorkspaceForm.resetFields(); setOpenTicketsModal();}}
      width={'80vw'}
    >
      <div className={styles.modalContent}>
        <KoTable rowKey='ticketId'
          onCellClick={onCellClick}
          onSort={onSort}
          data={{ columns: PROJECT_ITEMS_COLUMNS, rows: ticketList }}
        />
       
      </div>
    </KoModal>
    
  </div>;
}

export default Clients;
